import { render } from "./MyRegistrationsView.vue?vue&type=template&id=31f452f2&scoped=true"
import script from "./MyRegistrationsView.vue?vue&type=script&lang=js"
export * from "./MyRegistrationsView.vue?vue&type=script&lang=js"

import "./MyRegistrationsView.vue?vue&type=style&index=0&id=31f452f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f452f2"]])

export default __exports__